import axios from 'axios';
import axiosRetry from 'axios-retry';
import * as actions from './actionsTypes';
// import errorManage from '../errorManage';
import messages from '../messages';
import toastr from 'toastr';
import vaccinesServices from './vaccines.services';
// const client = axios.create({ baseURL: process.env.REACT_APP_URL });
// axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const resetVaccines = () => async (dispatch, getState) => {
  dispatch({
    type: actions.FORM_FAIL,
    payload: "",
  });
}

export const getVaccines = (params ,type) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_VACCINES,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(data.itype === 1 ? `/api/app/Formal_Vacuna/` : `/api/app/Funcional_Vacuna/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await vaccinesServices.getVaccines(params, type);
    dispatch({
      type: actions.GET_VACCINES,
      payload: {
        vacs: resp.data.data,
        vacsLength: resp.data.count
      }
    });
    dispatch({
      type: actions.VACCINES_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.VACCINES_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_VACCINES,
      payload: false
    });
  }
}

export const saveVaccines = (data, itype, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_VACCINES,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(itype === 1 ? `/api/app/Formal_Vacuna/` : `/api/app/Funcional_Vacuna/`, data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await vaccinesServices.saveVaccines(data, itype);
    const { vacs, vacsLength } = getState().vaccines;
    const aVacs = [...vacs, resp.data];
    dispatch({
      type: actions.GET_VACCINES,
      payload: {
        vacs: aVacs,
        vacsLength: vacsLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_VACCINES,
      payload: false
    });
  }
}

export const editVaccines = (data, id, index, itype, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_VACCINES,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(itype === 1 ? `/api/app/Formal_Vacuna/${id}/` : `/api/app/Funcional_Vacuna/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await vaccinesServices.editVaccines(id, data, itype);
    const { vacs, vacsLength } = getState().vaccines;
    vacs[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_VACCINES,
      payload: {
        vacs: vacs,
        vacsLength: vacsLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_VACCINES,
      payload: false
    });
  }
}

export const deleteVaccines = (id, index, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_VACCINES,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(itype === 1 ? `/api/app/Formal_Vacuna/${id}/` : `/api/app/Funcional_Vacuna/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await vaccinesServices.deleteVaccines(id, itype);
    const { vacs, vacsLength } = getState().vaccines;
    vacs.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_VACCINES,
      payload: {
        vacs: vacs,
        vacsLength: vacsLength -1
      }
    });
    dispatch({
      type: actions.VACCINES_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.VACCINES_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_VACCINES,
      payload: false
    });
  }
}